export default __webpack_public_path__ + "static/media/home_title.82bf7ec3.png";